import * as swcHelpers from '@swc/helpers';
import { uninitState, idleState, failedState, successState, loadingState, statusSuccess } from '@grandvisionhq/state';
import { UPDATE_USER_DATA_FAILED, UPDATE_USER_DATA_SUCCESS, UPDATE_USER_DATA, FETCH_USER_DATA_SUCCESS, FETCH_USER_DATA_FAILED, FETCH_USER_DATA } from './actions.js';

const initialState = {
    userData: uninitState(),
    updateCalls: {
        personalDetails: idleState(),
        billingAddress: idleState(),
        preferredStore: idleState()
    }
};
function userDataReducer(state = initialState, action) {
    switch(action.type){
        case FETCH_USER_DATA:
            return swcHelpers.objectSpread({}, state, {
                userData: loadingState()
            });
        case FETCH_USER_DATA_FAILED:
            return swcHelpers.objectSpread({}, state, {
                userData: failedState(action.error)
            });
        case FETCH_USER_DATA_SUCCESS:
            let updateUserData;
            if (state.userData && statusSuccess(state.userData)) {
                updateUserData = swcHelpers.objectSpread({}, state.userData.result, action.payload);
            } else {
                updateUserData = action.payload;
            }
            return swcHelpers.objectSpread({}, state, {
                userData: successState(updateUserData)
            });
        case UPDATE_USER_DATA:
            return swcHelpers.objectSpread({}, state, {
                updateCalls: swcHelpers.objectSpread({}, state.updateCalls, {
                    [action.payload.formName]: loadingState()
                })
            });
        case UPDATE_USER_DATA_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                userData: successState(action.payload.server),
                updateCalls: swcHelpers.objectSpread({}, state.updateCalls, {
                    [action.payload.formName]: idleState()
                })
            });
        case UPDATE_USER_DATA_FAILED:
            return swcHelpers.objectSpread({}, state, {
                updateCalls: swcHelpers.objectSpread({}, state.updateCalls, {
                    [action.payload.formName]: failedState(action.payload.error)
                })
            });
        default:
            return state;
    }
}

export { initialState, userDataReducer };
//# sourceMappingURL=reducer.js.map
